module.exports = __webpack_public_path__ + "static/coffeetalk1-cd2eb18bc2026d2c41897ea3692eb7c9.png";